import withAuth from '../utils/api';
import superagent from 'superagent';
import { useState } from 'react';

const useUndeploy = (
  tenant: number,
  modelId: number
): [
  { loading: boolean; error: string; done: boolean },
  () => Promise<void>
] => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>(null);
  const [done, setDone] = useState<boolean>(false);

  const undeploy = async () => {
    setLoading(true);
    try {
      await withAuth(
        superagent.put(`/api/tenant/${tenant}/model/${modelId}/undeploy`)
      );
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const err = error as any;
      if (err.response) {
        setError(err.response.body?.message || err.message);
      } else if (err.message) {
        setError(err.message);
      } else {
        setError('Unknown error occurred');
      }
    } finally {
      setLoading(false);
      setDone(true);
    }
  };

  return [{ loading, error, done }, undeploy];
};

export default useUndeploy;
